import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import moment from 'moment';

class OpinionListMeta extends Component {

	render() {
		return <div className="entry-meta">
			<b>Last Updated:</b> { this.props.last_updated }
		</div>;
	}
}

function mapStateToProps( { categories, catSource } ) {
	return { categories, catSource };
}

export default withRouter( connect( mapStateToProps )( OpinionListMeta ) );